if (!customElements.get('jupityr-signup-popup')) {
  customElements.define('jupityr-signup-popup', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || !this.dialog.showModal) return;
      this.storageKey = `dear-jupiter-signup:${location.hostname}`;
      this.pendingKey = `${this.storageKey}:pending`;
      this.legacyKey = `promo-bar-subscribed-${location.host}`;
      this.testMode = ['testing', 'success_testing'].includes(this.dataset.mode);
      const previewState = new URLSearchParams(location.search).get('signup_preview');
      this.forcedPreview = this.dataset.previewAllowed === 'true' && ['true', 'success'].includes(previewState);
      this.scrollPreview = this.dataset.previewAllowed === 'true' && previewState === 'scroll';
      const signal = this.events.signal;
      this.querySelectorAll('[data-signup-close]').forEach(button => button.addEventListener('click', () => this.close(), { signal }));
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); }, { signal });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.close();
      }, { signal });
      this.dialog.addEventListener('close', () => this.unlock(), { signal });
      this.querySelector('form').addEventListener('submit', () => {
        try { sessionStorage.setItem(this.pendingKey, 'true'); } catch {}
        this.querySelector('[type="submit"]').disabled = true;
      }, { signal });
      document.addEventListener('shopify:section:select', event => {
        if (event.detail.sectionId === this.dataset.sectionId) this.open();
      }, { signal });
      document.addEventListener('shopify:section:deselect', event => {
        if (event.detail.sectionId === this.dataset.sectionId) this.close(false);
      }, { signal });
      let pending = false;
      try { pending = sessionStorage.getItem(this.pendingKey) === 'true'; sessionStorage.removeItem(this.pendingKey); } catch {}
      const success = this.querySelector('[data-signup-success]');
      if (this.forcedPreview && previewState === 'success') {
        this.querySelector('[data-signup-entry]').hidden = true;
        success.hidden = false;
        this.open();
        return;
      }
      if (pending && success.dataset.posted === 'true') {
        this.querySelector('[data-signup-entry]').hidden = true;
        success.hidden = false;
        this.remember({ subscribed: true });
        try { localStorage.setItem(this.legacyKey, JSON.stringify({ subscribed: true })); } catch {}
        this.open();
        return;
      }
      if (pending && this.querySelector('[data-signup-error]')) { this.open(); return; }
      if (this.testMode || this.forcedPreview) { this.open(); return; }
      if (window.Shopify?.designMode || this.suppressed()) return;
      this.checkTrigger = () => {
        if (!this.delayElapsed || this.dialog.open || this.suppressed()) return;
        const scrollable = document.documentElement.scrollHeight - window.innerHeight;
        const reached = scrollable > 0 && window.scrollY / scrollable * 100 >= Number(this.dataset.scrollDepth || 25);
        if (this.dataset.trigger === 'scroll' && !reached) return;
        if (document.visibilityState !== 'visible' || document.querySelector('dialog[open], cart-drawer.active, .menu-drawer-container[open], details-modal details[open]')) return;
        this.open();
      };
      window.addEventListener('scroll', this.checkTrigger, { passive: true, signal });
      document.addEventListener('visibilitychange', this.checkTrigger, { signal });
      this.timer = setTimeout(() => { this.delayElapsed = true; this.checkTrigger(); }, Number(this.dataset.delaySeconds || 5) * 1000);
    }
    suppressed() {
      if (this.scrollPreview) return Boolean(this.dismissed);
      try {
        const state = JSON.parse(localStorage.getItem(this.storageKey) || '{}');
        const legacy = JSON.parse(localStorage.getItem(this.legacyKey) || '{}');
        return state.subscribed || legacy.subscribed || (state.dismissedUntil || 0) > Date.now();
      } catch { return this.dismissed; }
    }
    remember(state) { try { localStorage.setItem(this.storageKey, JSON.stringify(state)); } catch {} }
    open() {
      if (this.dialog.open || !this.isConnected) return;
      this.previousFocus = document.activeElement;
      this.dialog.querySelectorAll('img[data-src]').forEach(image => { image.src = image.dataset.src; delete image.dataset.src; });
      this.dialog.showModal();
      document.documentElement.classList.add('jupityr-signup-open');
      const success = this.querySelector('[data-signup-success]:not([hidden])');
      const heading = success ? success.querySelector('h2') : this.querySelector('.jupityr-signup__heading');
      if (heading) { this.dialog.setAttribute('aria-labelledby', heading.id); heading.focus({ preventScroll: true }); }
    }
    close(remember = true) {
      if (remember && !this.testMode && !this.forcedPreview) {
        this.dismissed = true;
        if (!this.suppressed()) this.remember({ dismissedUntil: Date.now() + Number(this.dataset.delayDays || 30) * 86400000 });
      }
      this.dialog.close();
      this.previousFocus?.focus({ preventScroll: true });
    }
    unlock() { document.documentElement.classList.remove('jupityr-signup-open'); }
    disconnectedCallback() { clearTimeout(this.timer); this.events?.abort(); if (this.dialog?.open) { this.dialog.close(); this.unlock(); } }
  });
}
